import type { MapCharger, MapConnector, RfidCard } from '@/api/types'

export type Tone = 'success' | 'brand' | 'info' | 'warning' | 'danger' | 'neutral'

/** What a driver needs to know about a connector. An offline charger's connectors still say Available. */
export function connectorState(charger: Pick<MapCharger, 'status'>, k: Pick<MapConnector, 'status'>): { label: string; tone: Tone; startable: boolean } {
  if (charger.status === 'Offline') return { label: 'Offline', tone: 'neutral', startable: false }
  switch (k.status) {
    case 'Available':
      return { label: 'Free', tone: 'success', startable: true }
    case 'Preparing':
      return { label: 'Plugged in', tone: 'info', startable: true }
    case 'Charging':
    case 'SuspendedEV':
    case 'SuspendedEVSE':
      return { label: 'In use', tone: 'brand', startable: false }
    case 'Finishing':
      return { label: 'Finishing', tone: 'info', startable: false }
    case 'Reserved':
      return { label: 'Reserved', tone: 'info', startable: false }
    case 'Faulted':
      return { label: 'Out of order', tone: 'danger', startable: false }
    default:
      return { label: 'Unavailable', tone: 'neutral', startable: false }
  }
}

export const usableCard = (c: RfidCard) => c.is_active && !c.is_blocked && !c.is_expired

/** "Rs. 16/kWh"-style rate, or null when the plan has no fixed rate (time-of-day). */
export const connectorRate = (k: Pick<MapConnector, 'pricing_plan'>) => k.pricing_plan?.base_rate_per_kwh ?? null
